import type { CsvRow } from "../types";

// Shift each row's timestamp into targetYear, preserving month/day/time-of-day (UTC).
// Feb 29 source rows get clamped to Feb 28 when targetYear isn't a leap year, so
// Date.UTC doesn't silently roll them over to March 1.
export function normalizeYear(rows: CsvRow[], targetYear: number): CsvRow[] {
  return rows.map((row) => {
    const month = row.timestamp.getUTCMonth();
    const daysInTargetMonth = new Date(Date.UTC(targetYear, month + 1, 0)).getUTCDate();
    const safeDay = Math.min(row.timestamp.getUTCDate(), daysInTargetMonth);
    return {
      ...row,
      timestamp: new Date(
        Date.UTC(
          targetYear,
          month,
          safeDay,
          row.timestamp.getUTCHours(),
          row.timestamp.getUTCMinutes(),
          row.timestamp.getUTCSeconds(),
          row.timestamp.getUTCMilliseconds()
        )
      ),
    };
  });
}
